import { Link } from "react-router-dom";
import managedServices from "../../../images/managedServices.png";
export const ManagedServices = ({ description }) => {
  return (
    <section
      className=""
      style={{
        background: "#2F72BD",
        maxWidth: "1280px",
        display: "flex",
        flexDirection: "column",
        justifySelf: "center",
        marginInline: "30px",
      }}
    >
      <div
        className="managedServices"
        style={{ color: "#FFFFFF", padding: "30px" }}
      >
        <div>
          <h2 style={{ color: "#FFFFFF" }}>Managed Services</h2>
          <p>{description}</p>
          <Link to="/contact-us" className="btn btn-secondary btn-lg shadow">
            Get in Touch
          </Link>
        </div>
        <img src={managedServices} alt="" />
      </div>
    </section>
  );
};
